import {
  
  ChatAltIcon,
  CreditCardIcon,
  FastForwardIcon,
} from "@heroicons/react/outline";
import { ReactComponent as Factura } from "../../assets/facturas2.svg";
import { ReactComponent as Internet } from "../../assets/svg/servicios/internet-azul.svg";
import { ReactComponent as Television } from "../../assets/svg/servicios/tv.svg";
import { ReactComponent as Telefonía } from "../../assets/svg/servicios/telefonia.svg";
import { ReactComponent as Reportes } from "../../assets/svg/servicios/reportes.svg";
import { ReactComponent as Pagos } from "../../assets/svg/pagos2-azul.svg";
import { ReactComponent as NetGo } from "../../assets/svg/netuno-go-azul.svg";
import { ReactComponent as exit } from "../../assets/salir.svg";
import { ReactComponent as PhoneIcon } from "../../assets/svg/servicios/datos.svg";

export const servicios = [
  {
    name: "Servicios Internet",
    description:
      "Consulta tu servicio de internet, plan, estatus, consumo y equipo.",
    href: "/cuenta/servicio-de-internet",
    icon: Internet,
  },
  
  {
    name: "Servicios Televisión",
    description:
      "Consulta tu servicio de televisión, plan, estatus y  equipo.",
    href: "/cuenta/servicio-de-television",
    icon: Television,
  },
  {
    name: "Servicios Televisión Streaming",
    description: "Consulta tu servicio y correo electrónico asociado  al servicio de streaming.",
    href: "/cuenta/servicio-de-streaming",
    icon: NetGo,
  },
  {
    name: "Servicios Telefonía",
    description:
      "Consulta tu servicio de telefonía, plan, estatus.",
    href: "/cuenta/servicio-de-telefonia",
    icon: Telefonía,
  },
];
export const serviciosComporativo = [
  {
    name: "Servicios Internet",
    description:
      "Consulta tu servicio de internet, plan, estatus, consumo y equipo.",
    href: "/cuenta/servicio-de-internet",
    icon: Internet,
  },
  {
    name: "Servicios Datos",
    description: "Consulta tu servicio de datos, plan y estatus.",
    href: "/cuenta/servicio-de-datos",
    icon: PhoneIcon,
  },
  {
    name: "Servicios Televisión Streaming",
    description: "Consulta tu servicio y correo electrónico asociado  al servicio de streaming.",
    href: "/cuenta/servicio-de-streaming",
    icon: NetGo,
  },
  {
    name: "Servicios Telefonía",
    description:
      "Consulta tu servicio de telefonía, plan, estatus.",
    href: "/cuenta/servicio-de-telefonia",
    icon: Telefonía,
  },
];
export const reportes = [
  {
    name: "Reportes",
    description: "Consulta de requerimientos o casos.",
    href: "/cuenta/ver-reportes",
    icon: Reportes,
  },
];
export const pagosResidecial = [
  {
    name: "Saldo",
    description: "Consulta tu balance actual.",
    href: "/cuenta/saldo",
    icon: Pagos,
  },
  {
    name: "Pagos",
    description: "Medios de pago y notificación.",
    href: "/cuenta/pagos",
    icon: Pagos,
  },
  // {
  //   name: "Notificaciones y Retenciones",
  //   description: "Notificar transferencias, depósitos y retenciones.",
  //   href: "/cuenta/notificacion-retenciones",
  //   icon: Pagos,
  // },  
  {
    name: "Domiciliación",
    description: "Domicilia el pago de tus servicios.",
    href: "/cuenta/domiciliacion",
    icon: Pagos,
  }
];

export const pagosEmpresarial = [
  {
    name: "Saldo",
    description: "Consulta tu balance actual.",
    href: "/cuenta/saldo",
    icon: Pagos,
  },  
  {
    name: "Pagos",
    description: "Medios de pago y notificación.",
    href: "/cuenta/pagos",
    icon: Pagos,
  },
  {
    name: "Notificaciones y Retenciones",
    description: "Notificar transferencias, depósitos y retenciones.",
    href: "/cuenta/notificacion-retenciones",
    icon: Pagos,
  },
  {
    name: "Domiciliación",
    description: "Domicilia el pago de tus servicios.",
    href: "/cuenta/domiciliacion",
    icon: Pagos,
  }

];
export const facturas = [
  {
    name: "Facturas",
    description: "Consulta y descarga tus facturas.",
    href: "/cuenta/ver-facturas",
    icon: Factura,
  },
];

export const menuResposive = [
  {
    name: "Servicios Internet",
    description:
      "Consulta tu servicio de internet, plan, estatus, consumo y equipo.",
    href: "/cuenta/servicio-de-internet",
    icon: Internet,
  },
  
 {
    name: "Servicios Televisión " ,
    description: "Consulta tu servicio de televisión, plan, estatus y  equipo." ,
    href:  "/cuenta/servicio-de-television" ,
    icon:  Television ,
  },
  {
    name: "Servicios Televisión Streaming",
    description: "Consulta tu servicio y correo electrónico asociado  al servicio de streaming.",
    href: "/cuenta/servicio-de-streaming",
    icon: NetGo,
  },
  {
    name: "Servicios Telefonía",
    description:
      "Consulta tu servicio de telefonía, plan, estatus.",
    href: "/cuenta/servicio-de-telefonia",
    icon: Telefonía,
  },
  {
    name: "Saldo",
    description: "Consulta tu balance actual.",
    href: "/cuenta/saldo",
    icon: Pagos,
  },  
  {
    name: "Pagos",
    description: "Medios de pago y notificación.",
    href: "/cuenta/pagos",
    icon: Pagos,
  },
  // {
  //   name: "Notificaciones y Retenciones",
  //   description: "Notificar transferencias, depósitos y retenciones.",
  //   href: "/cuenta/notificacion-retenciones",
  //   icon: Pagos,
  // },   
  {
    name: "Domiciliación",
    description: "Domicilia el pago de tus servicios.",
    href: "/cuenta/domiciliacion",
    icon: Pagos,
  },
  {
    name: "Reportes",
    description: "Consulta de requerimientos o casos.",
    href: "/cuenta/ver-reportes",
    icon: Reportes,
  },
  {
    name: "Facturas",
    description: "Consulta y descarga tus facturas.",
    href: "/cuenta/ver-facturas",
    icon: Factura,
  },
  {
    name: "Salir",
    description: "Salir",
    href: "/cuenta/salir",
    icon: exit,
  },
];
export const menuResponsiveCorporativo = [
  {
    name: "Servicios Internet",
    description:
      "Consulta tu servicio de internet, plan, estatus, consumo y equipo.",
    href: "/cuenta/servicio-de-internet",
    icon: Internet,
  },
  {
    name: "Servicios Datos",
    description: "Consulta tu servicio de datos, plan y estatus.",
    href: "/cuenta/servicio-de-datos",
    icon: PhoneIcon,
  },
  {
    name: "Servicios Televisión Streaming",
    description: "Consulta tu servicio y correo electrónico asociado  al servicio de streaming.",
    href: "/cuenta/servicio-de-streaming",
    icon: NetGo,
  },
  {
    name: "Servicios Telefonía",
    description:
      "Consulta tu servicio de telefonía, plan, estatus.",
    href: "/cuenta/servicio-de-telefonia",
    icon: Telefonía,
  },
  {
    name: "Pagos",
    description: "Medios de pago y notificación",
    href: "/cuenta/pagos",
    icon: Pagos,
  },
  {
    name: "Notificaciones y Retenciones",
    description: "Notificar transferencias, depósitos y retenciones.",
    href: "/cuenta/notificacion-retenciones",
    icon: Pagos,
  },
  {
    name: "Domiciliación",
    description: "Domicilia el pago de tus servicios.",
    href: "/cuenta/domiciliacion",
    icon: Pagos,
  },
  {
    name: "Reportes",
    description: "Consulta de requerimientos o casos",
    href: "/cuenta/ver-reportes",
    icon: Reportes,
  },
  {
    name: "Facturas",
    description: "Consulta y descarga tus facturas",
    href: "/cuenta/ver-facturas",
    icon: Factura,
  },
  {
    name: "Salir",
    description: "Salir",
    href: "/cuenta/salir",
    icon: exit,
  },


];
